// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vtsznbvllpwckwdhhqxz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ0c3puYnZsbHB3Y2t3ZGhocXh6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2NjcyMzgsImV4cCI6MjA3MjI0MzIzOH0.DTX1z5zDJEplsi8YT9yAf-6gPmA50vN8D68Mt4BkR-k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});